import { render, staticRenderFns } from "./bookingTypesPage.vue?vue&type=template&id=913ae42e&scoped=true&"
import script from "./bookingTypesPage.vue?vue&type=script&lang=ts&"
export * from "./bookingTypesPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../wellness/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "913ae42e",
  null
  
)

export default component.exports